import React, { useContext, useState } from 'react';
import LoginForm from '../../components/LoginForm';
import MicrosoftButtonLogin from '../../components/MicrosoftButtonLogin';
import { ContainerLogin, ButtonLogin, ButtonEsqueci, DividerContainer, DividerLine, DividerLabel } from './styled';
import { Form, FormControl, FormLabel } from 'react-bootstrap';
import axios from 'axios';

import { ErrorMessage, retornaPerfil } from '../../contents/VariaveisGlobais';
import { ConsumoAPI_POST, ConsumoAPI_PUT } from '../../../backend/ConsumoAPI';
import DisparaEmail from '../../../backend/DisparaEmail';
import { toast } from 'react-toastify';
import { ThemeContext } from '../../../App';
import { usePopUp } from '../../components/BootBox';

import menuDefault from '../../../lib/json/menu.json'
import { ConsultaAPI_URLQuery } from '../../../backend/ConsultaAPI';

function Login({ onLogin, setInstance, setAccount }){
	const { DisparaBootBox, FechaBootBox  } = usePopUp();

	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	
	var usuarioLogado = '{}';
	var empresaLogada = '';
	var nomeUsuario	  = '';
	var emailUsuario  = '';
	var novaSenha	  = '';
	
	const authenticateUser = async (username, password, email) => {
		const CURRENT_VERSION = window._env_?.REACT_APP_VERSION || process.env.REACT_APP_VERSION;

		try {
		  const response = await ConsumoAPI_POST('login', {
			email: username || email,
			senha: password,
			versao: CURRENT_VERSION
		  });
	  
		  const { user } = response;
	  
		  if (user) {
			// Definir a empresa logada e o usuário logado
			empresaLogada = user.empresaHabilitadas[0];
			usuarioLogado = JSON.stringify(user);
	  
			return {
			  success: true,
			  user: user
			};
		  }
		} catch (error) {
		  console.error('Erro ao autenticar usuário:', error.message);
		  return {
			success: false,
			message: 'Erro ao autenticar usuário.',
		  };
		}
	  
		return {
		  success: false,
		  message: 'Falha ao autenticar o Usuário.',
		};
	}
	
	const handleConfirmaEmail = async() => {
		if (!emailUsuario){
			toast.warning('O prenchimento do E-mail é obrigatório.');
			return
		}
		
		if (!validateEmail(emailUsuario)){
			toast.warning('E-mail não é valido.');
			return
		}

		const usuariosDados = await ConsultaAPI_URLQuery('usuarioSistema/check_user', emailUsuario, false );
		const userExist = usuariosDados.user;

		if (userExist){
			const senhaDefault = btoa("NpeGroup@" + Date.now());

			userExist.primeiroLogin = true
			userExist.senha = senhaDefault
			
			try {
				const retorno = await ConsumoAPI_PUT("usuarioSistema", userExist);

				if (retorno.error === "00"){
					await DisparaEmail({
						destinatario: emailUsuario,
						assunto: 'Recuperação de Senha - Tools System',
						corpo: `<p>Olá ${userExist.nome},</p>
								<p>Esperamos que você esteja bem.</p>
								<p>Conforme solicitado, segue abaixo sua senha provisória para acessar nosso sistema:</p>
								<p><strong>Senha Provisória: ${atob(senhaDefault)}</strong></p>
								<p>Por favor, utilize esta senha para fazer login em sua conta.</p>    
								<p>Ao realizar o login no sistema, será solicitado a você que crie uma nova senha. Recomendamos fortemente que você altere sua senha para garantir a segurança de sua conta.</p>`
					});
					
					toast.success("E-mail de Recuperação de Senha enviado!")
				}
			} catch (error) {
				console.error('Error saving JSON file', error);
			}
		}else{
			toast.warning('Este E-mail não está cadastrado.');
			return
		}
		
		FechaBootBox()
	}

	const handleEsqueciSenha = () => {
		const Mensagem = ( <>
			<FormLabel>E-mail</FormLabel>
				<FormControl
					type="text"
					onChange={handleCampoEmail}
				/>
			</>
		)
		
		const buttonsRender = [
			{ variant: 'primary', action: handleConfirmaEmail, label: 'Confirmar' },
			{ variant: 'secondary', action: FechaBootBox, label: 'Cancelar' }
		]
		
		emailUsuario  = '';

		DisparaBootBox('Recuperação de senha', Mensagem, buttonsRender, '0', null)
	}

	const handleMenuUsuario = async()=> {
		let menuSistema = JSON.stringify(menuDefault, null, 2)
		let usuario = JSON.parse(usuarioLogado);		
		
		if (usuario.usuario !== 'ADMIN'){
			let empresaHabilitadas = ''
			let parametrosEmpresas = ''
			//Verificar Perfil e pegar informação do Perfil
			const perfilId = JSON.parse(usuario.perfil).value
			
			if (perfilId){
				const dadosPerfil = await retornaPerfil()
				const perfil = dadosPerfil.perfil.find( (item) => item.idPerfil === parseInt(perfilId))
				menuSistema = perfil.menu;
				empresaHabilitadas = perfil.empresaHabilitadas;
				parametrosEmpresas = perfil.parametrosEmpresas;
			}else{
				menuSistema = usuario.menu;
				empresaHabilitadas = usuario.empresaHabilitadas;
				parametrosEmpresas = usuario.parametrosEmpresas;
			}
			
			usuario.empresaHabilitadas = empresaHabilitadas;
			usuario.parametrosEmpresas = parametrosEmpresas;
		}
		
		usuario.menu = menuSistema;
		usuario.tema = usuario.tema || 'dark';                
		usuarioLogado = JSON.stringify(usuario);
	}

	const handleLogin = async() => {
		if (username.trim() === '' || password.trim() === '') {
			setError('Por favor, preencha todos os campos.');
			return;
		}

		const isAuthenticated = await authenticateUser(username, password);

		if (isAuthenticated.success) {
			isSenhaProvisoria()

			await handleMenuUsuario()
			onLogin(username, usuarioLogado, empresaLogada);
		} else {
			setError('Nome de usuário ou senha incorretos.');
			
			
			const usersData = await ConsultaAPI_URLQuery('usuarioSistema/check_user', username, false);
			const userExist = usersData.user;
			
			if (userExist === undefined && validateEmail(username)){
				const Mensagem = ( <>
						<FormLabel>Nome Completo</FormLabel>
						<FormControl
							type="text"
							onChange={handleCampoNome}
						/>
					</>
				)
				
				const buttonsRender = [
					{ variant: 'primary', action: handleConfirmaNovoUsuario, label: 'Confirmar' },
					{ variant: 'secondary', action: FechaBootBox, label: 'Cancelar' }
				]
				
				nomeUsuario  = '';

				DisparaBootBox('Solicitação de cadastro de Usuário', Mensagem, buttonsRender, '0', null)	
			}
		}
	};

	const handleLoginMicrosoft = async(data, email) => {
		const isAuthenticated = await authenticateUser(null, null, email);
		
		if (isAuthenticated.success) {
			let usuario = await JSON.parse(usuarioLogado);
			
			isSenhaProvisoria()
			await handleMenuUsuario()
			onLogin(usuario.usuario, usuarioLogado, empresaLogada);
		} else {
			gravarUsuario(email, data.account.name)
		}
	};
	
	const handleConfirmaNovoUsuario = async(id) => {
		if (!nomeUsuario){
			toast.warning('O prenchimento do Nome Completo é obrigatório.');
			return
		}
		
		FechaBootBox()
		gravarUsuario(username, nomeUsuario, password)
    };

	const isSenhaProvisoria = () => {
		let usuario = JSON.parse(usuarioLogado)
		if (usuario.primeiroLogin){
			const Mensagem = ( <>
					<FormLabel>Nova Senha</FormLabel>
					<FormControl
						type="password"
						onChange={handleNovaSenha}
					/>
				</>
			)
			
			const buttonsRender = [
				{ variant: 'primary', action: handleConfirmaNovaSenha, label: 'Confirmar' },
				{ variant: 'secondary', action: FechaBootBox, label: 'Cancelar' }
			]
			
			novaSenha  = '';

			DisparaBootBox('Alteração de Senha Provisória - Tools System', Mensagem, buttonsRender, '0', null)	
		}
	}

	const validateEmail = (email) => {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const isValidEmail = regex.test(email);
		
		return isValidEmail;
	};

	const handleCampoEmail = (e) =>{
		const valueUpper = e.target.value.toUpperCase() 
        emailUsuario = valueUpper
	}

	const handleCampoNome = (e) =>{
		const valueUpper = e.target.value.toUpperCase() 
        nomeUsuario = valueUpper
	}

	const handleNovaSenha = (e) =>{
        novaSenha = e.target.value
	}

	const handleConfirmaNovaSenha = () => {
		if (!novaSenha){
			toast.warning('O prenchimento da Nova Senha é obrigatório.');
			return
		}

		FechaBootBox()
		let usuario = JSON.parse(usuarioLogado)
		atualizaUsuario(usuario, novaSenha)
	}

	const LoadJSON = async(name) => {
		try {
			// Construct the public URL for the JSON file
			const jsonUrl = `/lib/${name}.json`;
			
			const response = await axios.get(jsonUrl, {
				headers: {
					'Cache-Control': 'no-cache, no-store, must-revalidate',
					'Pragma': 'no-cache',
					'Expires': '0',
				},
			});
			
			const data = await response.data;
			
			// Set the data in the component's state
			return data
		} catch (error) {
			console.error('Error fetching JSON:', error);
		}
	};

	const gravarUsuario = async(email, nome, password) => {
		var usuarioSave = await LoadJSON("usuarioDefault")
		const usuariosDados = await ConsultaAPI_URLQuery('usuarioSistema/check_user', email, false );
		let userExist = usuariosDados.user

		if (userExist === undefined){
			usuarioSave.nome = nome.toUpperCase()
			usuarioSave.email = email.toUpperCase()
			usuarioSave.usuario = email.split("@")[0].toUpperCase()
			usuarioSave.habilitado = false
			usuarioSave.primeiroLogin = true
			
			if (password){
				usuarioSave.senha = btoa(password)
				usuarioSave.primeiroLogin = false
			}
	
			// UsuariosJSON = { ...usuariosDados };
			// UsuariosJSON.usuarios.push(usuarioSave)
			
			try {
				const response = await ConsumoAPI_POST("usuarioSistema", usuarioSave);
				
				if (response.error === "00"){
					await DisparaEmail({
						destinatario: 'erick.peres@npegroup.com.br;mateus.b.silva@npegroup.com.br;fabio@npegroup.com.br',
						assunto: 'Solicitação de Criação de Usuario - Tools System',
						corpo: `<p><strong>Detalhes da Conta:</strong></p>
						<p><strong>Nome de Usuário:</strong> ${usuarioSave.usuario}</p>
						<p><strong>E-mail Cadastrado:</strong> ${usuarioSave.email}</p>`
					});
					
					setError('Criado nova solicitação de usuário junto ao Departamento de TI');
				}
			} catch (error) {
				console.error('Error saving JSON file', error);
			}
		}else{
			setError('Solicitação de usuário já realizada junto ao Departamento de TI');
		}
	}

	const atualizaUsuario = async(usuario, novaSenha) => {
		let usuarioSave = usuario
		
		usuarioSave.senha = btoa(novaSenha)
		usuarioSave.primeiroLogin = false

		try {
			await ConsumoAPI_PUT("usuarioSistema", usuarioSave);
		} catch (error) {
			console.error('Error saving JSON file', error);
		}
	}

	return (
		<ContainerLogin className="d-flex align-items-center justify-content-center">
			<Form.Group>
				<LoginForm onLogin={onLogin} onChangeUser={setUsername} onChangePassword={setPassword}/>
				
				{error && <ErrorMessage message={error} />}
				
				{username.trim() !== '' && password.trim() !== '' && (
					<ButtonLogin variant="primary" type="button" onClick={handleLogin}>
						Login
					</ButtonLogin>
				)}
				
				<ButtonEsqueci type="button" variant={"btn"} onClick={handleEsqueciSenha}>
					Esqueci minha senha
				</ButtonEsqueci>

				<DividerContainer>
					<DividerLine />
					<DividerLabel>ou</DividerLabel>
					<DividerLine />
				</DividerContainer>
				<MicrosoftButtonLogin 
					onMicrosoftLogin={handleLoginMicrosoft} 
					changeInstance={setInstance}
					changeAccount={setAccount}
				/>
			</Form.Group>
		</ContainerLogin>
	);
};

export default Login;
